import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTimezones } from '../api/timezones';
import { Timezone } from '../@types';
import { TimezonesKey } from '../configs/timezones';

export const useGetTimezones = (): UseQueryResult<[Timezone]> => {
  return useQuery({
    queryKey: [TimezonesKey],
    queryFn: () => getTimezones(),
    staleTime: 5 * 60 * 60 * 1000
  });
};